import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';
import './event-tile.component.scss';
var EventTile = /** @class */ (function (_super) {
    tslib_1.__extends(EventTile, _super);
    function EventTile(element) {
        var _this = _super.call(this, element) || this;
        _this.autoHeight = 'true';
        return _this;
    }
    EventTile.prototype.init = function () {
        var _this = this;
        if (this.element.getAttribute('data-autoheight')) {
            this.autoHeight = this.element.getAttribute('data-autoheight').toString();
        }
        this.tabComponent = $(this.element);
        this.tabsContent = Array.from(this.tabComponent.find('.event-tile__item-content'));
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
        this.initTabs();
        this.slideRunner = this.tabComponent.find('.event-tile__slide-runner');
        this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
        this.activeTabTrigger = this.tabComponent.find('.event-tile__item--active');
        this.activeTab = this.tabComponent.find('.event-tile__item-content--active');
        this.dropdown = this.element.querySelector('.js-option-selector');
        this.slideRunner = this.tabComponent.find('.event-tile__slide-runner');
        this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
        this.activeTabTrigger = this.tabComponent.find('.event-tile__item--active');
        this.activeTab = this.tabComponent.find('.event-tile__item-content--active');
        $(document).ready(function () {
            _this.moveSlideRunner();
        });
    };
    EventTile.prototype.bindEvents = function () {
        var _this = this;
        this.tabTriggers.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleTabs(event);
            _this.moveSlideRunner();
        }); });
        window.addEventListener('resize', this.debounce(function () {
            _this.moveSlideRunner();
        }, 250, false));
        window.addEventListener('resize', this.onResize.bind(this));
        this.dropdown.addEventListener('change', function (event) {
            var element = event.target;
            var index = element.selectedIndex;
            var value = element.value;
            _this.dropdownSelection(value, index);
        });
    };
    EventTile.prototype.onResize = function () {
        var _this = this;
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
    };
    EventTile.prototype.initTabs = function () {
        var tabs = this.tabComponent.find('.event-tile__item');
        var tabsContent = this.tabsContent;
        for (var i = 0; i < tabs.length; i++) {
            var tabGuid = this.generateGuid();
            $(tabs[i]).attr('data-target', "event-tile__item-" + tabGuid);
            $(tabsContent[i]).attr('id', "event-tile__item-" + tabGuid);
        }
    };
    EventTile.prototype.equalHeights = function () {
        if (this.autoHeight == 'true') {
            var elements = this.tabsContent;
            for (var i = 0; i < elements.length; i++) {
                if (!elements[i].classList.contains('event-tile__item-content--active')) {
                    elements[i].style.height = '0';
                }
                else {
                    elements[i].style.height = 'auto';
                }
            }
            if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {
                var tallestElement = 0;
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    if (el.classList.contains('event-tile__item-content--active')) {
                        var elHeight = el.offsetHeight;
                        if (elHeight > tallestElement) {
                            tallestElement = elHeight;
                        }
                    }
                }
                for (var i = 0; i < elements.length; i++) {
                    elements[i].style.height = tallestElement + "px";
                    if (!elements[i].classList.contains('event-tile__item-content--active')) {
                        elements[i].style.height = '0';
                    }
                }
            }
        }
    };
    EventTile.prototype.toggleTabs = function (event) {
        if (!$(event.currentTarget).hasClass('event-tile__item--active')) {
            this.closeTab();
            this.activeTabTrigger = $(event.currentTarget);
            this.activeTab = this.tabComponent.find("#" + this.activeTabTrigger.attr('data-target'));
            this.openTab();
        }
        this.equalHeights();
    };
    EventTile.prototype.moveSlideRunner = function () {
        var tabPositionLeft = this.activeTabTrigger.position().left;
        var tabWidth = this.activeTabTrigger.width();
        this.slideRunner
            .width(0)
            .css('left', tabPositionLeft + "px")
            .show()
            .delay(350)
            .width(tabWidth);
    };
    EventTile.prototype.generateGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    EventTile.prototype.closeTab = function () {
        this.activeTabTrigger.removeClass('event-tile__item--active');
        this.activeTab.removeClass('event-tile__item-content--active');
    };
    EventTile.prototype.openTab = function () {
        this.activeTabTrigger.addClass('event-tile__item--active');
        this.activeTab.addClass('event-tile__item-content--active');
    };
    EventTile.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    EventTile.prototype.dropdownSelection = function (value, index) {
        if (index == 0) {
            index = 4;
        }
        if (index && value) {
            if (index == 4) {
                index = 0;
            }
            this.tabsContent.map(function (item, indexContent) {
                item.classList.remove('event-tile__item-content--active');
                item.style.height = '0';
                if (indexContent === index) {
                    item.classList.add('event-tile__item-content--active');
                    item.style.height = 'auto';
                }
            });
            this.tabTriggers.map(function (item, indexTabItem) {
                item.classList.remove('event-tile__item--active');
                if (indexTabItem === index) {
                    item.classList.add('event-tile__item--active');
                }
            });
        }
    };
    return EventTile;
}(Base));
export { EventTile };



//////////////////
// WEBPACK FOOTER
// ./components/event-tile/event-tile.component.ts
// module id = 276
// module chunks = 0